import React from "react";
import { Link, NavLink } from "react-router-dom";

const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-xl navbar-light bg-orange bold-600">
      <div className="container-fluid">
        <div className="large-screen">
          <div className="navbar-brand mx-2 d-flex">
            <a href="https://www.iitp.ac.in/" target={"_blank"}>
              <img
                className="logo-img"
                src="https://upload.wikimedia.org/wikipedia/en/thumb/5/52/Indian_Institute_of_Technology%2C_Patna.svg/1200px-Indian_Institute_of_Technology%2C_Patna.svg.png"
              />
            </a>

            <span className="vl mx-3"></span>
            <div className="text-uppercase align-items-center">
              <a
                className="remove-underline color-white"
                href="https://www.iitp.ac.in/"
                target={"_blank"}
              >
                <div className="iitp">Indian Institute of Technology Patna</div>
              </a>
              <a
                className="remove-underline"
                href="https://www.iitp.ac.in/index.php/departments/engineering-technology/chemical-and-biochemical-engineering"
                target={"_blank"}
              >
                <div className="cbe">
                  Department of Chemical and Biochemical
                </div>
              </a>
            </div>
            <span className="vl mx-3"></span>
            <div className="row text-uppercase align-items-center">
              <Link className="remove-underline color-white" to="/~atanu.metya/">
                <div className="tmrg">The metya Research Group</div>
              </Link>
            </div>
          </div>
        </div>
        <div className="small-screen">
          <div className="navbar-brand mx-2 d-flex">
            <div className="row">
              <a href="https://www.iitp.ac.in/" target={"_blank"}>
                <img
                  className="logo-img"
                  src="https://upload.wikimedia.org/wikipedia/en/thumb/5/52/Indian_Institute_of_Technology%2C_Patna.svg/1200px-Indian_Institute_of_Technology%2C_Patna.svg.png"
                />
              </a>
              <br />
              <div className="text-uppercase align-items-center">
                <a
                  className="remove-underline color-white"
                  href="https://www.iitp.ac.in/"
                  target={"_blank"}
                >
                  <div className="tmrg">
                    Indian Institute of Technology Patna
                  </div>
                </a>
                <a
                  className="remove-underline"
                  href="https://www.iitp.ac.in/index.php/departments/engineering-technology/chemical-and-biochemical-engineering"
                  target={"_blank"}
                >
                  <div className="cbe">
                    Department of Chemical and Biochemical
                  </div>
                </a>
                <Link className="remove-underline color-white" to="/~atanu.metya/">
                  <div className="tmrg">The Metya Research group</div>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <button
          className="navbar-toggler mx-2 mt-2"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className="collapse navbar-collapse justify-content-end"
          id="navbarSupportedContent"
        >
          <ul className="navbar-nav mb-2 mb-lg-0">
            <li className="nav-item">
              <NavLink
                className="nav-link mx-2"
                to="/~atanu.metya/"
              >
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className="nav-link mx-2"
                to="/~atanu.metya/research/interfacialPhenomenaAndNanoconfinement"
              >
                Research
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className="nav-link mx-2"
                to="/~atanu.metya/publications/refereedJournal"
              >
                Publications
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className="nav-link mx-2"
                to="/~atanu.metya/people/currentMembers"
              >
                People
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className="nav-link mx-2"
                to="/~atanu.metya/resources"
              >
                Resources
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className="nav-link mx-2"
                to="/~atanu.metya/fundings"
              >
                Fundings
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className="nav-link mx-2"
                to="/~atanu.metya/joinUs"
              >
                JoinUs
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
